import restClient from './BackendRestClient';


export function getCookiesConsentVisible() {
    return restClient.get(["system-settings", "cookies-consent-visible"].join("/"))
        .then(res => res)
}

export function getCookiesPolicyLink() {
    return restClient.get(["system-settings", "cookies-policy"].join("/"))
        .then(res => res)
}

export function getDataPrivacyLink() {
    return restClient.get(["system-settings", "data-privacy"].join("/"))
        .then(res => res)
}
